import { ELEMENT_LI, ELEMENT_OL, ELEMENT_UL } from "@udecode/plate-list";
import { ELEMENT_PARAGRAPH } from "@udecode/plate-paragraph";
import { MARK_BOLD, MARK_ITALIC, MARK_UNDERLINE } from "@udecode/plate-basic-marks";
import { withProps } from "@udecode/plate-common";
import { StyledElement, StyledLeaf } from "@udecode/plate-styled-components";
import { DefaultPlatePluginKey } from "./options";
import { PlatePluginComponent } from "@udecode/plate-core";
import { MARK_HIGHLIGHT } from "@udecode/plate-highlight";

export const createSlatePluginsComponents = <T extends string = string>(
  overrides?: Partial<Record<DefaultPlatePluginKey | T, PlatePluginComponent>>
) => {
  const components = {
    [ELEMENT_LI]: withProps(StyledElement, { as: "li" }),
    [ELEMENT_UL]: withProps(StyledElement, {
      as: "ul",
      styles: {
        root: {
          margin: 0,
          paddingInlineStart: "24px",
        },
      },
    }),
    [ELEMENT_OL]: withProps(StyledElement, {
      as: "ol",
      styles: {
        root: {
          margin: 0,
          paddingInlineStart: "24px",
        },
      },
    }),
    [ELEMENT_PARAGRAPH]: withProps(StyledElement, {
      as: "p",
      styles: {
        root: {
          margin: 0,
          padding: "4px 0",
        },
      },
    }),
    [MARK_BOLD]: withProps(StyledLeaf, { as: "strong" }),
    [MARK_HIGHLIGHT]: withProps(StyledLeaf, {
      as: "mark",
      styles: {
        root: {
          backgroundColor: "#FEF3B7",
        },
      },
    }),
    [MARK_ITALIC]: withProps(StyledLeaf, { as: "em" }),
    [MARK_UNDERLINE]: withProps(StyledLeaf, { as: "u" }),
  };

  if (overrides) {
    Object.keys(overrides).forEach((key) => {
      const override = overrides[key as DefaultPlatePluginKey];
      if (override) {
        components[key as DefaultPlatePluginKey] = override;
      }
    });
  }

  return components as Record<DefaultPlatePluginKey | T, PlatePluginComponent>;
};
